<template>
  <v-form ref="form" @submit.prevent="submit" v-model="formValid">
    <v-row>
      <v-col cols="12">
        <p class="font-weight-bold black--text quotation-title mb-7">
          SEGURADO
        </p>
      </v-col>
    </v-row>
    <v-row class="pb-12">
      <v-col cols="12" sm="4" class="pr-0 pr-sm-5">
        <DocumentInput
          id-element="cpfCnpjInsuredQuotation"
          placeholder="Inserir"
          v-model.lazy="formInsured.numero_documento"
          required
          :rules="[requiredInput, isValidCpfOrCnpj]"
          validate-on-blur
          label-text="CPF/CNPJ"
          document-type="hybrid"
        />
      </v-col>
      <v-col cols="12" sm="8" class="pr-0">
        <BaseFormInput
          id-element="nameInsuredQuotation"
          placeholder="Inserir"
          v-model="formInsured.nome"
          required
          :rules="[requiredInput, isValidName]"
          label-text="Nome"
          hide-no-data
          item-text="nome"
          :return-object="false"
          :template-insured="true"
        />
      </v-col>
      <v-col cols="12" sm="4" class="pr-0 pr-sm-5">
        <BaseFormInput
          id-element="celularInsuredQuotation"
          placeholder="Inserir"
          v-model="formInsured.celular"
          required
          :rules="[requiredInput]"
          validate-on-blur
          v-facade="maskPhone"
          label-text="Celular"
        />
      </v-col>
      <v-col cols="12" sm="8" class="pr-0">
        <BaseFormInput
          id-element="emailInsuredQuotation"
          placeholder="Inserir"
          v-model="formInsured.email"
          label-text="E-mail"
        />
      </v-col>
    </v-row>
    <v-row class="pb-2">
      <v-col>
        <p class="font-weight-bold black--text quotation-title mb-1">
          Crédito Rural
        </p>
        <v-divider class="mb-2" />
      </v-col>
    </v-row>
    <v-row class="pb-2">
      <div class="d-flex mb-0 pr-sm-10">
        <p class="darkBluishGray--text caption mb-0">
          Proposta será garantia de crédito rural?
        </p>
        <v-switch
          v-model="formInsured.credito_rural.is_credito_rural"
          class="pa-0 ma-0 ml-5"
          color="secondary"
          inset
          hide-details
          dense
        />
        <p class="pl-1 mb-0 d-inline-block darkBluishGray--text body-2">
          {{ creditoRuralText }}
        </p>
      </div>
    </v-row>
    <div v-if="formInsured.credito_rural.is_credito_rural">
      <v-row class="pb-12">
        <v-col cols="12" sm="4" class="pr-0 pr-sm-5">
          <DocumentInput
            id-element="cpfCnpjBeneficiaryInsuredQuotation"
            placeholder="Inserir"
            v-model="formInsured.credito_rural.documento_beneficiario"
            required
            :rules="[requiredInput, isValidCpfOrCnpj]"
            validate-on-blur
            label-text="CPF/CNPJ"
            document-type="hybrid"
          />
        </v-col>
        <v-col cols="12" sm="8" class="pr-0">
          <BaseFormInput
            id-element="nameBeneficiaryInsuredQuotation"
            placeholder="Inserir"
            v-model="formInsured.credito_rural.nome_beneficiario"
            required
            :rules="[requiredInput, isValidNameBeneficiario]"
            label-text="A favor de"
            hide-no-data
            item-text="nome"
            :return-object="false"
            :template-insured="true"
          />
        </v-col>
        <v-col cols="12" sm="4" class="pr-sm-5">
          <BaseMoney
            id-element="valueCreditRural"
            placeholder="0,00"
            label-text="Valor do crédito"
            v-model="formInsured.credito_rural.valor_credito_rural"
            required
            :rules="[requiredInput]"
            :errorMessages="valorCreditoRuralErrorMessages"
            :v-on:change="validateValorCreditoRural()"
          />
        </v-col>
      </v-row>
    </div>
    <BaseFooter>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="5" md="3" class="pr-0 pr-sm-5 pb-5 pb-sm-0">
          <BaseButton
            v-html="'CANCELAR SOLICITAÇÃO'"
            class="white--text pink"
            width="100%"
            @click="cancelQuotation"
          />
        </v-col>
        <v-col cols="12" sm="5" md="3">
          <BaseButton
            v-html="'PRÓXIMO'"
            class="white--text secondary"
            width="100%"
            @click="submit()"
          />
        </v-col>
      </v-row>
    </BaseFooter>
  </v-form>
</template>
<script>
import {
  requiredInput,
  isValidCpfOrCnpj,
  isValidCep,
  isValidEmail,
  maxLengthNumber
} from "@/utils/rules.js";
import { maskPhone } from "@/utils/masks.js";
import { brazilianStates } from "@/utils/utils.js";
import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import CompanyMixin from "@/mixins/CompanyMixin";
import { formatCpfOrCnpf } from "@/utils/formats";
import DocumentInput from "@/components/form/DocumentInput.vue";
import _ from "lodash";
const nameRegex = /^[A-zÀ-ÿ'-]+\s([A-zÀ-ÿ'-]\s?)*[A-zÀ-ÿ']+$/;

export default {
  data: () => ({
    formValid: true,
    loading: false,
    requiredInput,
    isValidCpfOrCnpj,
    maskPhone,
    brazilianStates,
    searchName: null,
    searchCPFCNPJ: null,
    timeout: null,
    isValidCep,
    isValidEmail,
    maxLengthNumber,
    formatCpfOrCnpf,
    valorCreditoRuralErrorMessages: [],
    money: {
      decimal: ",",
      thousands: ".",
      prefix: "R$ ",
      suffix: "",
      precision: 2,
      masked: false /* doesn't work with directive */
    }
  }),
  computed: {
    ...mapState(["loadingStatus"]),
    ...mapState("quotation", ["insuredByNameOrCPFCNPJ"]),
    formInsured: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    isValidName() {
      return (
        nameRegex.test(this.formInsured.nome) ||
        nameRegex.test(this.formInsured.nome?.nome) ||
        "Nome de segurado deve ter nome e sobrenome válidos"
      );
    },
    isValidNameBeneficiario() {
      return (
        nameRegex.test(this.formInsured.credito_rural.nome_beneficiario) ||
        nameRegex.test(
          this.formInsured.credito_rural.nome_beneficiario?.nome_beneficiario
        ) ||
        "Nome do beneficiário deve ter nome e sobrenome válidos"
      );
    },
    creditoRuralText() {
      return this.formInsured.credito_rural.is_credito_rural ? "SIM" : "NÃO";
    }
  },
  mixins: [LoadingRequest, CompanyMixin],
  components: { DocumentInput },
  methods: {
    ...mapActions(["hasLoading", "showAlertNotification"]),
    cancelQuotation() {
      this.$emit("cancel");
    },
    validateValorCreditoRural() {
      if (
        this.formInsured.credito_rural.valor_credito_rural > 0 &&
        this.valorCreditoRuralErrorMessages.length != 0
      ) {
        this.valorCreditoRuralErrorMessages = [];
      }
    },
    submit() {
      if (!this.$refs.form.validate()) {
        this.validateInputBaseMoney();

        this.showAlertNotification({
          message: "Preencha todos os campos corretamente antes de prosseguir.",
          type: "error"
        });
        return;
      }

      const document = (this.formInsured.numero_documento || "").replace(
        /\D/g,
        ""
      );
      this.formInsured.tipo_pessoa = {
        id: document.length === 11 ? "pessoa_fisica" : "pessoa_juridica"
      };

      this.$emit("submit", this.value);
    },
    validateInputBaseMoney() {
      if (
        !this.formInsured.credito_rural.valor_credito_rural > 0 &&
        this.valorCreditoRuralErrorMessages.length == 0
      ) {
        this.valorCreditoRuralErrorMessages.push("Este campo é obrigatório");
      }
    },
    autocompleteFormAccordingInput(value, input) {
      // Se selecionar um elemento do back-end, deve-se autocompletar
      // a tabela inteira conforme o elemente selecionado
      const item = this.insuredByNameOrCPFCNPJ.find(x => x[input] == value);
      if (item) {
        this.formInsured = this.mergeProperties(
          _.cloneDeep(item),
          this.formInsured
        );
        this.formInsured.numero_documento = this.formatCpfOrCnpf(
          item.numero_documento
        );
      }
    }
  },
  props: {
    value: {
      type: Object
    },
    optionsQuotation: {
      type: Object
    },
    form: {
      type: Object
    }
  },
  watch: {
    "formInsured.numero_documento"(newValue, oldValue) {
      // Tenho que garantir que o valor antigo não é o
      // mesmo do valor atual para não entrar num loop infinito
      // e como o valor pode ser tanto um objeto ou string,
      // preciso fazer teste para ambos.
      if (!newValue || newValue == oldValue) return;
      const item = newValue?.id || newValue;
      const type = newValue?.id ? "id" : "numero_documento";
      this.autocompleteFormAccordingInput(item, type);
    },
    "formInsured.nome"(newValue, oldValue) {
      // Tenho que garantir que o valor antigo não é o
      // mesmo do valor atual para não entrar num loop infinito
      // e como o valor pode ser tanto um objeto ou string,
      // preciso fazer teste para ambos.
      if (!newValue || newValue == oldValue) return;
      const item = newValue?.id || newValue;
      const type = newValue?.id ? "id" : "nome";
      this.autocompleteFormAccordingInput(item, type);
    }
  }
};
</script>
